<template>
  <div id="CompareProductWithChart">
    <div class="productContainer">
      <div
        class="d-flex justify-content-between align-items-center brandLogoWithName mb-2"
      >
        <div
          class="productImageContainer"
          style="
            text-transform: capitalize;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.05) 0%,
              rgba(255, 255, 255, 0) 100%
            );
            border-bottom: 1px solid #ebebeb;
          "
        >
          <img
            v-if="productImage"
            :src="productImage"
            class="img-fluid"
            style="mix-blend-mode: multiply; height: 100%; object-fit: cover"
          />
          <img
            v-else
            src="../../../public/Icons_SVG/noProductImageForComparison.svg"
            class="img-fluid"
          />
        </div>
        <div class="mx-3 my-2" style="width: 70%">
          <h3
            class="productHeading"
            data-toggle="tooltip"
            data-placement="top"
            :title="`${storeProductInfo.productName}`"
          >
            {{ storeProductInfo.productName }}
          </h3>
          <!-- <h4 class="productType" v-if="productType === 'primaryProduct'">Primary Product</h4>
                    <h4 class="productType" v-else-if="productType === 'secondaryProduct'">Competitor Product</h4> -->
          <h4 class="productType" v-if="productType">
            {{ translatedLang[productType][selectedLanguage.key] }}
          </h4>
          <div class="product-name-selection mt-4">
            <div
              class="customMultiselect ml-0 mt-3"
              v-if="productDropdown.length"
            >
              <treeselect
                v-model="productSelectSku"
                :show-count="true"
                @select="getProductDataOnChangeInput"
                :options="productDropdown"
                value-consists-of="LEAF_PRIORITY"
                :disable-branch-nodes="true"
                placeholder="Select Product Name"
                :searchable="true"
              >
                <span slot="noResult"
                  >Oops! No elements found. Consider changing the search
                  query.</span
                >
              </treeselect>
            </div>
          </div>
        </div>
      </div>
      <div>
        <lineChart :data="storeProductInfo.finalTrendLine" />
      </div>
    </div>
    <div class="bankOffersContainer mt-3 pb-2">
      <h4
        style="
          border-bottom: 1px solid #d4d4d4;
          color: #5e5e5e;
          font-weight: 500;
        "
        class="pb-2"
      >
        {{ translatedLang["Offers"][selectedLanguage.key] }}
      </h4>
      <div v-for="offer in productOffers" class="tw-mt-6">
        <h3 class="tw-font-semibold tw-text-lg tw-mb-3">
          {{ offer.platform_name }}
        </h3>

        <!-- Wrapper -->
        <div class="tw-space-y-4">
          <div v-if="offer.coupon" class="tw-flex">
            <div class="tw-min-w-[150px] tw-max-w-[150px] tw-font-semibold">{{ translatedLang["Coupon"][selectedLanguage.key] }}</div>
            <div class=" tw-space-y-1">
              <div>
                {{ offer.coupon }}
              </div>
            </div>
          </div>
          <!-- BANK OFFERS -->
          <div
            v-if="offer.bank_offers && offer.bank_offers.length"
            class="tw-flex"
          >
            <div class="tw-min-w-[150px] tw-max-w-[150px] tw-font-semibold">
              {{ translatedLang["Bank Offers"][selectedLanguage.key] }}
            </div>
            <div>
              <div
                v-for="(bank, index) in offer.bank_offers.slice(0, 10)"
                :key="'bank' + index"
                class="tw-mb-2"
              >
                {{ bank }}
                <a
                  class="offerSeeDetails tw-text-blue-600 tw-underline tw-ml-1"
                  target="_blank"
                  :href="offer.redirect_url"
                >
                  {{ translatedLang["See Details"][selectedLanguage.key] }}
                </a>
              </div>
            </div>
          </div>

          <!-- CASHBACK OFFERS -->
          <div
            v-if="offer.cashback_offers && offer.cashback_offers.length"
            class="tw-flex"
          >
            <div class="tw-min-w-[150px] tw-max-w-[150px] tw-font-semibold">
              {{ translatedLang["Cashback Offers"][selectedLanguage.key] }}
            </div>
            <div>
              <div
                v-for="(cashback, index) in offer.cashback_offers.slice(0, 10)"
                :key="'cashback' + index"
                class="tw-mb-2"
              >
                {{ cashback }}
                <a
                  class="offerSeeDetails tw-text-blue-600 tw-underline tw-ml-1"
                  target="_blank"
                  :href="offer.redirect_url"
                >
                  {{ translatedLang["See Details"][selectedLanguage.key] }}
                </a>
              </div>
            </div>
          </div>

          <!-- PARTNER OFFERS -->
          <div
            v-if="offer.partner_offers && offer.partner_offers.length"
            class="tw-flex"
          >
            <div class="tw-min-w-[150px] tw-max-w-[150px] tw-font-semibold">
              {{ translatedLang["Partner Offers"][selectedLanguage.key] }}
            </div>
            <div>
              <div
                v-for="(partner, index) in offer.partner_offers.slice(0, 10)"
                :key="'partner' + index"
                class="tw-mb-2"
              >
                {{ partner }}
                <a
                  class="offerSeeDetails tw-text-blue-600 tw-underline tw-ml-1"
                  target="_blank"
                  :href="offer.redirect_url"
                >
                  {{ translatedLang["See Details"][selectedLanguage.key] }}
                </a>
              </div>
            </div>
          </div>

          <!-- OTHER OFFERS -->
          <div
            v-if="offer.other_offers && offer.other_offers.length"
            class="tw-flex"
          >
            <div class="tw-min-w-[150px] tw-max-w-[150px]  tw-font-semibold">
              {{ translatedLang["Other Offers"][selectedLanguage.key] }}
            </div>
            <div>
              <div
                v-for="(other, index) in offer.other_offers.slice(0, 10)"
                :key="'other' + index"
                class="tw-mb-2"
              >
                {{ other }}
                <a
                  class="offerSeeDetails tw-text-blue-600 tw-underline tw-ml-1"
                  target="_blank"
                  :href="offer.redirect_url"
                >
                  {{ translatedLang["See Details"][selectedLanguage.key] }}
                </a>
              </div>
            </div>
          </div>

          <!-- FALLBACK -->
          <div
            v-if="
              (!offer.bank_offers || !offer.bank_offers.length) &&
              (!offer.cashback_offers || !offer.cashback_offers.length) &&
              (!offer.partner_offers || !offer.partner_offers.length) &&
              (!offer.other_offers || !offer.other_offers.length)
            "
            class="text-gray-600"
          >
            {{
              translatedLang["No offers available for this platform."][
                selectedLanguage.key
              ]
            }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="patnerOffersContainer mt-3">
            <p class="py-3">10% Instant Discount up to INR 1250 on ICICI Bank Credit Card Non-EMI Trxn (excluding Amazon
                Pay ICICI Bank Credit Card). Min trxn is INR 5000</p>
            <p class="py-3">Additional INR 1500 Instant Discount on ICICI Bank Credit Card Trxn (excluding Amazon Pay
                ICICI Bank
                Credit Card). Min trxn is INR 74999</p>
            <p class="py-3">Additional INR 1000 Instant Discount on ICICI Bank Credit Card Trxn (excluding Amazon Pay
                ICICI Bank Credit Card). Min trxn is INR 49999</p>
        </div>
        <div class="otherOffersContainer mt-3">
            <p class="py-3">10% Instant Discount up to INR 1250 on ICICI Bank Credit Card Non-EMI Trxn (excluding Amazon
                Pay ICICI Bank Credit Card). Min trxn is INR 5000</p>
            <p class="py-3">Additional INR 1500 Instant Discount on ICICI Bank Credit Card Trxn (excluding Amazon Pay
                ICICI Bank
                Credit Card). Min trxn is INR 74999</p>
            <p class="py-3">Additional INR 1000 Instant Discount on ICICI Bank Credit Card Trxn (excluding Amazon Pay
                ICICI Bank Credit Card). Min trxn is INR 49999</p>
        </div> -->
  </div>
</template>

<script>
import lineChart from "../commonCharts/lineChart.vue";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";
export default {
  name: "CompareProductWithChart",
  components: { lineChart, Treeselect },
  props: [
    "productSelectSku",
    "productDropdown",
    "getProductDataOnChangeInput",
    "productType",
    "storeProductInfo",
    "productImage",
    "productOffers",
    "showHeading",
  ],

  mounted() {
    // console.log(data, 'graph')
    // console.log(this.productSelectSku)
  },

  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },

  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
  },
};
</script>

<style>
/* .product-name-selection :focus {
    background: var(--base_color-5);
    color: var(--primary_brand-60);
    border: 1px solid var(--primary_brand-60) !important;
    outline: none;
    box-shadow: none;
    font-weight: 600;
} */

.product-name-selection .form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 14px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.productContainer {
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  overflow: hidden;
  /* box-shadow: 0 8px 24px rgba(149,157,165,.2); */
  /* box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px; */
  margin-right: 1px !important;
}

.brandLogoWithName {
  box-shadow: 0px 1px 6px 0px #0000002e;
  border-bottom: 1px solid #d9d9d9;
  border-radius: 0 0 10px 10px;
  /* height: 240px; */
  /* overflow: hidden; */
}

/* 
.productHeading {
    color: #065559;
    font-weight: 500;
    text-transform: capitalize;
} */

.productHeading,
.productType {
  line-height: 21.76px;
  letter-spacing: -0.01em;
  font-size: 16px;
  font-family: Poppins;
}

.productType {
  color: #5e5e5e;
  font-weight: 400;
}

.productImageContainer {
  width: 183px !important;
  height: 170px !important;
  display: flex;
  justify-content: center;
  padding: 6px;
}

.productHeading {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 10px !important;
  color: #065559;
  font-weight: 500;
  text-transform: capitalize;
  margin-right: 15px !important;
}

.bankOffersContainer,
.otherOffersContainer,
.patnerOffersContainer {
  color: #5e5e5e;
  font-size: 14px;
  padding: 0 10px;
  border-top: 1px solid #ddd;
  /* border-radius: 10px; */
  padding-top: 10px;
}

.bankOffersContainer {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.bankOffersContainer::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 6px;
  background: #ebedee;
}

.bankOffersContainer::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.bankOffersContainer::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: #b3b2b9;
}

.bankOffersContainer::-webkit-scrollbar-thumb:hover {
  background: #8b8d94;
  cursor: pointer;
}

.bankOffersContainer h3 {
  font-size: 16px;
  font-family: "Poppins";
  font-weight: 700;
  color: #5e5e5e;
}

.offerSeeDetails {
  color: #065559 !important;
  text-decoration-line: underline !important;
  margin-left: 9px !important;
  cursor: pointer !important;
}
</style>
